import React from 'react';
import ChartComponent from './ChartComponent';

const OrdersPerWeekChart = ({ data, startDate, endDate }) => {

  const sortedData = [...data].sort((a, b) => new Date(a.created_at) - new Date(b.created_at));

  // Step 1: Process the data to count orders per week
  const ordersPerWeek = {};

  sortedData.forEach(order => {
    const date = new Date(order.created_at);
    // Get ISO week number
    const weekNumber = getWeekNumber(date);
    const year = date.getFullYear();
    const weekLabel = `Week ${weekNumber}, ${year}`;

    if (ordersPerWeek[weekLabel]) {
      ordersPerWeek[weekLabel] += 1;
    } else {
      ordersPerWeek[weekLabel] = 1;
    }
  });


  const fullData = {};
  const start = new Date(startDate);
  const end = new Date(endDate);

  for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 7)) {
    const weekNumber = getWeekNumber(d);
    const year = d.getFullYear();
    const weekLabel = `Week ${weekNumber}, ${year}`;
    fullData[weekLabel] = ordersPerWeek[weekLabel] || 0;
  }

  // Helper function to get ISO week number
  function getWeekNumber(d) {
    d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
    d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
    const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    const weekNo = Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
    return weekNo;
  }

  // Prepare data for Chart.js
  const chartData = {
    labels: Object.keys(fullData),
    datasets: [
      {
        label: 'Number of Orders',
        data: Object.values(fullData),
        backgroundColor: 'rgba(255, 159, 64, 0.6)', // Bar color
        borderColor: 'rgba(255, 159, 64, 1)', // Bar border color
        borderWidth: 2,
        tension: 0.4, // Smooth curve for line chart
        pointRadius: 5, // Makes the points on the line more visible
        pointBackgroundColor: 'rgba(255, 159, 64, 1)',
      },
    ],
  };

  // Define chart options
  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        display: false, // Hide the legend for a cleaner look
      },
      title: {
        display: true,
        text: 'Orders Per Week', // Chart title
        font: {
          size: 18,
          weight: 'bold',
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true, // Y-axis starts at zero
        title: {
          display: true,
          text: 'Number of Orders', // Y-axis title
          font: {
            size: 14,
          },
        },
        ticks: {
          callback: function (value) {
            return value // Add an order icon before the value
          },
          stepSize: 1, // Step size for y-axis
        },
        grid: {
          display: false, // Remove grid lines for a cleaner look
        },
      },
      x: {
        title: {
          display: true,
          text: 'Week', // X-axis title
          font: {
            size: 14,
          },
        },
        grid: {
          display: false, // Remove grid lines
        },
        offset: true,
        ticks: {
          autoSkip: false,
        },
      },
    },
  };

  return (
    <div style={{ height: '100%', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <ChartComponent type="line" data={chartData} options={chartOptions} />
    </div>
  );
};

export default OrdersPerWeekChart;
